import SkinAPI from "@api/lol/Skin.api";
import ButtonVariants from "@core-components/button/ButtonVariants";
import useAppTranslation from "@hooks/language/useAppTranslation";
import SSSearch from "@modules/skins/SkinSearch/components/SkinSearch";
import type IChampion from "@modules/skins/shared/models/IChampion.model";
import { IconSearch } from "@tabler/icons-react";
import { useEffect, useMemo, useRef, useState } from "react";

const HomeSearch = () => {
  const { t } = useAppTranslation("pages.home.title.search");

  const [search, setSearch] = useState("");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [championAndSkins, setChampionAndSkins] = useState<IChampion[]>([]);
  const filteredChampionsAndSkins = useMemo(
    () =>
      championAndSkins.filter(
        (champion) =>
          champion.skins.some((skin) =>
            skin.name.toLowerCase().includes(search.toLowerCase()),
          ) || champion.name.toLowerCase().includes(search.toLowerCase()),
      ),
    [championAndSkins, search],
  );

  useEffect(() => {
    setIsLoading(true);
    SkinAPI.getSkinsGroupedByChampions()
      .then((res) => setChampionAndSkins(res.data))
      .finally(() => setIsLoading(false));
  }, []);

  const searchRef = useRef<HTMLInputElement>(null);

  return (
    <SSSearch
      ref={searchRef}
      isNew
      ariaLabel={t("ariaLabel")}
      className="w-80 font-inter text-primary-default/75 sm:w-[450px] md:w-[536px]"
      classNames={{
        root: "bg-primary-white py-2 hover-fade-white",
        input: "font-inter !text-primary-default",
        dropdown: "bg-primary-white",
        option: "hover:bg-primary-white text-primary-default",
        text: "text-primary-default",
      }}
      placeholder={t("placeholder")}
      rightSection={
        <ButtonVariants.ActionIcon
          showDefault={false}
          className="text-primary-dark-text"
          title={t("title")}
          variant="transparent"
          onClick={() => searchRef.current?.focus()}
        >
          <IconSearch />
        </ButtonVariants.ActionIcon>
      }
      isLoading={isLoading}
      value={search}
      values={filteredChampionsAndSkins}
      withLeftSection={false}
      onChange={setSearch}
    />
  );
};

export default HomeSearch;
